import React, { useState, useEffect, useRef } from "react";
import withMainLayout from "../HOC/withMainLayout";
import { Modal } from "react-bootstrap";
import Images from "../Helper/AllImages";
import { useHistory, useParams, withRouter, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { ResponsiveLine } from "@nivo/line";
import Chart from "react-apexcharts";
import { linearGradientDef } from "@nivo/core";

import {
  getDoubleSwapOutput,
  getSwapSlip,
  getDoubleSwapSlip,
  PoolData,
  getValueOfAssetInRune,
  getValueOfRuneInAsset,
  getSwapOutput,
  getSwapFee,
  getSwapOutputWithFee,
  getDoubleSwapOutputWithFee,
} from "@thorchain/asgardex-util";

import {
  nativeSwapping,
  handleMainModal,
  serverDecryption,
  NGROK,
  getOutboundTxFee,
  calculateNetworkFee,
} from "../../Services/mainServices";
import Setting_Modal from "../PopModals/Setting_Modal";
import { CRYPTOCOMPARE_KEY } from "../../Services/environment";
import { dark } from "@mui/material/styles/createPalette";
import {
  assetFromString,
  assetToString,
  baseAmount,
} from "@xchainjs/xchain-util";
import { INBOUND_ADDRESSES } from "../../Routes/serverRoutes";

const BuyPlatform = (props) => {
  const match = props.match;
  const [Enum, set_Enum] = useState({
    allType: "allType",
    native: "native",
    erc20: "erc20",
    bep2: "bep2",
  });
  const fromMarket = "op";
  const myRefSwap = useRef();
  const myRefSwap2 = useRef();

  let history = useHistory();
  const dispatch = useDispatch();

  const { id } = useParams();
  const [filterType, setFilterType] = useState(Enum.allType);
  const [filterType2, setFilterType2] = useState(Enum.allType);

  const [YayModal, setYayModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [fromAmount, setFromAmount] = useState("");
  const [slipValue, setSlipValue] = useState(0);
  const [memoSlip, setMemoSlip] = useState(0);
  const [toAmount, setToAmount] = useState("");
  const [slipError, setSlipError] = useState(false);
  const [mainError, setMainError] = useState(false);
  const [transactionHash, setTransactionHash] = useState("");
  const [TokenPriceUSD, setTokenPriceUSD] = useState("");
  const [tokenData, setTokenData] = useState(null);
  const [keyStore, setKeyStore] = useState([]);
  const [selectedCurr, setSelectedCurr] = useState(null);
  const [statusLink, setStatusLink] = useState("");
  const [loading, setLoading] = useState(false);
  const [toOptionDropDown, setToOptionDropDown] = useState(false);
  const [selectedCurrTo, setSelectedCurrTo] = useState("");
  const [optionsDropdown, setOptionsDropdown] = useState(false);
  const [networkFee, setNetworkFee] = useState(0);
  const mainState = useSelector((state) => state.main.midgardPool);
  const graphState = useSelector((state) => state.main.graphDataCombined);
  const candleGraphState = useSelector((state) => state.main.candleGraphData);
  const walletType = useSelector((state) => state.main.walletType);
  const [midgardData, setMidgardData] = useState([]);
  const loggedin = useSelector((state) => state.main.isLoggedin);
  const assetBalance = useSelector((state) => state.main.assetBalance);
  const midgardPool = useSelector((state) => state.main.midgardPool);
  const [graphData, setGraphData] = useState([]);
  const [search, setSearch] = useState("");
  const [slippagePercent, setSlippagePercent] = useState(0);
  const [updatedGraphData, setUpdatedGraphData] = useState();
  const [selectedFilter, setSelectedFilter] = useState("1D");
  const [graphData1D, setGraphData1D] = useState([]);
  const [graphData1H, setGraphData1H] = useState([]);
  const [graphData1M, setGraphData1M] = useState([]);
  const [graphData1Y, setGraphData1Y] = useState([]);
  const [emptyError, setEmptyError] = useState(false);

  const [graphCroppedData1H, setGraphCroppedData1H] = useState([]);
  const [graphCroppedData1D, setGraphCroppedData1D] = useState([]);
  const [graphCroppedData1M, setGraphCroppedData1M] = useState([]);
  const [graphCroppedData1Y, setGraphCroppedData1Y] = useState([]);
  const [fromDataMain, setFromDataMain] = useState();
  const [candleGraph, setCandleGraph] = useState([]);
  // let fromDataMain;
  // useEffect(() => {
  //   console.log("===== DDD ======== ", graphData1D);
  //   console.log("===== HHH ======== ", graphData1H);
  //   console.log("===== MMM ======== ", graphData1M);
  //   console.log("===== YYY ======== ", graphData1Y);
  // }, [graphData1H, graphData1M, graphData1Y, graphData1D]);

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
    function handleClick(e) {
      if (myRefSwap && myRefSwap.current) {
        const ref = myRefSwap.current;
        if (!ref.contains(e.target)) {
          setOptionsDropdown(false);
        }
      }
      if (myRefSwap2 && myRefSwap2.current) {
        const ref = myRefSwap2.current;
        if (!ref.contains(e.target)) {
          setToOptionDropDown(false);
        }
      }
    }
  }, []);

  //MAIN ERROR

  useEffect(() => {
    setSlipError(false);
    setToAmount("");
    setFromAmount("");
    setSlipError(false);
    setSlipValue(0);
    if (
      selectedCurr?.asset?.ticker === selectedCurrTo?.asset &&
      selectedCurr?.asset?.chain === selectedCurrTo?.blockchain
    ) {
      setMainError(true);
    } else {
      setMainError(false);
    }
  }, [selectedCurrTo, selectedCurr]);

  //SLIPPAGE IMPLEMENTATION

  useEffect(async () => {
    setSlipError(false);
    setToAmount("");
    setSlipValue(0);
    if (slippagePercent && selectedCurrTo && selectedCurr && fromAmount) {
      if (fromAmount && fromAmount > 0) {
        let fromData;
        if (selectedCurr?.asset?.ticker === "RUNE") {
          fromData = RUNE;
        } else {
          fromData = midgardPool.find(
            (data) =>
              data.blockchain === selectedCurr.asset.chain &&
              data.asset === selectedCurr.asset.ticker
          );
        }
        let isRUNE = false;
        if (
          selectedCurrTo?.asset === "RUNE" &&
          selectedCurrTo?.blockchain === "THOR"
        ) {
          isRUNE = true;
        }
        let fromPoolSlip = {
          runeBalance: baseAmount(fromData?.runeDepth),
          assetBalance: baseAmount(fromData?.assetDepth),
        };
        let toPoolSlip = {
          runeBalance: baseAmount(selectedCurrTo?.runeDepth),
          assetBalance: baseAmount(selectedCurrTo?.assetDepth),
        };
        // console.log("FROM AMOUNT+========", fromAmount);
        // console.log("FROM AMOUNT+========", isRUNE);
        // console.log("FROM AMOUNT+========", fromPoolSlip.runeBalance.amount());
        // console.log("FROM AMOUNT+========", fromPoolSlip.assetBalance.amount());

        let response;
        if (isRUNE) {
          response = await getSwapSlip(
            baseAmount(fromAmount * 10 ** 8),
            fromPoolSlip,
            isRUNE
          );
        } else if (
          selectedCurr?.asset?.ticker === "RUNE" &&
          selectedCurr?.asset?.chain === "THOR"
        ) {
          response = await getSwapSlip(
            baseAmount(fromAmount * 10 ** 8),
            toPoolSlip,
            isRUNE
          );
        } else {
          response = await getDoubleSwapSlip(
            baseAmount(fromAmount * 10 ** 8),
            fromPoolSlip,
            toPoolSlip
          );
        }

        let slipValueVar = response.c[0] / 10 ** 12;
        console.log("Slip Value========", Number(slipValueVar));
        setSlipValue(
          slipValueVar.toFixed(
            1 - Math.floor(Math.log(slipValueVar) / Math.log(10))
          )
        );
        let response2;
        let slipValueMemo;
        // MINIMUM RECIEPIENT
        if (isRUNE) {
          response = await getSwapOutputWithFee(
            baseAmount(fromAmount * 10 ** 8),
            fromPoolSlip,
            isRUNE,
            baseAmount(1)
          );
          response2 = await getSwapOutput(
            baseAmount(fromAmount * 10 ** 8),
            fromPoolSlip,
            isRUNE
          );
          slipValueMemo = (100 - slippagePercent) / 100;
          slipValueMemo = slipValueMemo * response2.amount();
          console.log("TORUNE");
        } else if (
          selectedCurr?.asset?.ticker === "RUNE" &&
          selectedCurr?.asset?.chain === "THOR"
        ) {
          response = await getSwapOutputWithFee(
            baseAmount(fromAmount * 10 ** 8),
            toPoolSlip,
            isRUNE,
            baseAmount(1)
          );
          response2 = await getSwapOutput(
            baseAmount(fromAmount * 10 ** 8),
            toPoolSlip,
            isRUNE
          );
          slipValueMemo = (100 - slippagePercent) / 100;
          slipValueMemo = slipValueMemo * response2.amount();
          console.log("FROMRUNE");
        } else {
          response = await getDoubleSwapOutputWithFee(
            baseAmount(fromAmount * 10 ** 8),
            fromPoolSlip,
            toPoolSlip,
            baseAmount(1)
          );
          response2 = await getDoubleSwapOutput(
            baseAmount(fromAmount * 10 ** 8),
            fromPoolSlip,
            toPoolSlip
          );

          slipValueMemo = (100 - slippagePercent) / 100;
          slipValueMemo = slipValueMemo * response2.amount();
          console.log("DIFFERENT");
        }
        let slipWithDecimal = slipValueMemo / 10 ** 8;
        console.log("SLIP WITH DECIMAL=========", slipWithDecimal);
        if (slipValueVar <= slippagePercent && slipWithDecimal > 0) {
          let check = slipWithDecimal.toString().split(".");
          let res = check[1].substring(0, 4);
          res = res + "333";
          setMemoSlip(res);

          setToAmount(response.amount().c[0] / 10 ** 8);
        } else {
          setSlipError(true);
        }
      }
    }
  }, [fromAmount]);
  // useEffect(() => {

  //   if (selectedFilter == "1D") {
  //     setGraphData(graphData1D);
  //   } else if (selectedFilter == "1H") {
  //     setGraphData(graphData1H);
  //   } else if (selectedFilter == "1M") {
  //     setGraphData(graphData1M);
  //   } else if (selectedFilter == "1Y") {
  //     setGraphData(graphData1Y);
  //   }
  // }, [selectedFilter]);

  // useEffect(() => {}, [selectedCurr, selectedCurrTo]);

  useEffect(() => {
    if (graphState?.length > 0) {
      if (tokenData) {
        let res = graphState?.filter(
          (d) => d.assetName.split("-")[0] === tokenData?.rawData.split("-")[0]
        );
        setUpdatedGraphData(res);

        const graph1D = res[0]?.graphData1D;
        const graph1H = res[0]?.graphData1Hr;
        const graph1M = res[0]?.graphData1M;
        const graph1Y = res[0]?.graphData1Y;

        // console.log("graph1D<><><><><><><<><><><><><><><>", graph1D);
        let finalData = graph1D?.map((data, k) => {
          return {
            x:
              new Date(Number(data.timeStamp) * 1000)
                .toString()
                .substring(4, 10) +
              " " +
              new Date(Number(data.timeStamp) * 1000)
                .toString()
                .substring(16, 21),
            y: data.assetPriceUSD,
          };
        });

        let finalData2 = graph1H?.map((data, k) => {
          return {
            x:
              new Date(Number(data.timeStamp) * 1000)
                .toString()
                .substring(4, 10) +
              " " +
              new Date(Number(data.timeStamp) * 1000)
                .toString()
                .substring(16, 21),
            y: data.assetPriceUSD,
          };
        });

        let finalData3 = graph1M?.map((data, k) => {
          return {
            x: new Date(Number(data.timeStamp) * 1000)
              .toString()
              .substring(0, 21),
            y: data.assetPriceUSD,
          };
        });

        let finalData4 = graph1Y?.map((data, k) => {
          if (!isNaN(data.assetPriceUSD)) {
            return {
              x: new Date(Number(data.timeStamp) * 1000)
                .toString()
                .substring(0, 16),
              y: data.assetPriceUSD,
            };
          } else {
            return {
              x: 0,
              y: 0,
            };
          }
        });

        setGraphData1D([
          {
            id: res?.[0]?.assetName,
            color: "hsl(344, 70%, 50%)",
            data: [...finalData],
          },
        ]);

        setGraphData1H([
          {
            id: res?.[0]?.assetName,
            color: "hsl(344, 70%, 50%)",
            data: [
              // { x: 0, y: 0 },
              ...finalData2,
            ],
          },
        ]);

        setGraphData1M([
          {
            id: res?.[0]?.assetName,
            color: "hsl(344, 70%, 50%)",
            data: [
              // { X: 0, y: 0 },
              ...finalData3,
            ].slice(0, -1),
          },
        ]);

        setGraphData1Y([
          {
            id: res?.[0]?.assetName,
            color: "hsl(344, 70%, 50%)",
            data: [...finalData4].slice(0, -1),
          },
        ]);

        let data1h = [];
        let data1d = [];
        let data1m = [];
        let data1y = [];

        for (let i = 1; i < finalData2.length; i += 3) {
          data1h.push(finalData2[i]);
        }

        for (let i = 1; i < finalData.length; i += 90) {
          data1d.push(finalData[i]);
        }

        let final3 = finalData3?.slice(0, -1);

        for (let i = 1; i < finalData3.length; i += 180) {
          data1m.push(final3[i]);
        }

        let final4 = finalData4?.slice(0, -1);

        for (let i = 1; i < finalData4.length; i += 90) {
          data1y.push(final4[i]);
        }

        setGraphCroppedData1H(data1h);
        setGraphCroppedData1D(data1d);
        setGraphCroppedData1M(data1m);
        setGraphCroppedData1Y(data1y);

        console.log("=-=-=RRRRRRR-=-=-=>", res?.[0]?.assetName);
        console.log("=-=-=1D DATAAAAAAAAAAA-=-=-=>", finalData);
        console.log("=-=-=1H DATAAAAAAAAAAA-=-=-=>", finalData2);
        console.log("=-=-=1M DATAAAAAAAAAAA-=-=-=>", finalData3);
        console.log("=-=-=1Y DATAAAAAAAAAAA-=-=-=>", finalData4);
        console.log("=-=-=1HHHHHHHHHHHHHHHHHHHHHH-=-=-=>", data1m);

        // setGraphData(graphData1D);
      }
    }
    if (tokenData) {
      setSelectedCurrTo(tokenData);
    }

    if (candleGraphState?.length) {
      console.log("______CANDLEGRAPHSTATE________ ", candleGraphState);
      console.log("TOKEN DATA ______ ", tokenData);
      console.log("ASSET NAME ______ ", tokenData?.rawData?.split("-")[0]);
      console.log("ASSET Compare Check ______ ", candleGraphState);

      const filtered = candleGraphState.filter(
        (d) => d.assetName?.split("-")[0] == tokenData?.rawData.split("-")[0]
      );

      console.log("<><>< FILTERED CANDLE <><><<><> ", filtered);

      const filteredCandle = filtered[0]?.data?.map((d) => {
        return {
          x: new Date(d.x * 1000).toString().substring(4, 16),
          y: d.y,
        };
      });
      console.log("______ FILTERED CANDLE _____ ", filteredCandle);
      setCandleGraph([{ data: filteredCandle }]);
    }
  }, [tokenData]);

  const [displayLineGraph, setDisplayLineGraph] = useState(true);
  const RUNE = {
    asset: "RUNE",
    blockchain: "THOR",
    assetFullName: "Rune",
    rawData: "THOR.RUNE",
    logo: Images.runeImg,
    address: "",
  };
  useEffect(() => {
    let XRUNE;
    let result = assetBalance.filter((d) => {
      if (d?.asset?.ticker === "RUNE" && d?.asset?.chain === "THOR") {
        XRUNE = d;
      }
      return d?.asset?.ticker !== "RUNE" && d?.asset?.chain !== "THOR";
    });

    if (XRUNE) {
      result.unshift(XRUNE);
    }

    setKeyStore(result);
  }, [assetBalance]);

  useEffect(() => {
    if (mainState) {
      setMidgardData([...mainState]);
    }
  }, [mainState]);

  useEffect(() => {
    if (midgardData) {
      midgardData.unshift(RUNE);
    }
  }, [midgardData]);
  useEffect(async () => {
    if (selectedCurr && tokenData) {
      setToAmount("");
      setFromAmount("");
      await axios
        .get(
          `https://min-api.cryptocompare.com/data/price?fsym=${selectedCurrTo?.asset}&tsyms=${selectedCurr?.asset?.ticker}&api_key=${CRYPTOCOMPARE_KEY}`
        )
        .then((res) => {
          console.log("res===>>", res.data);
          setTokenPriceUSD(res.data[Object.keys(res.data)[0]]);
        });
    }
  }, [selectedCurr, selectedCurrTo]);

  useEffect(() => {
    if (!loggedin) {
      history.push("/");
    }
  }, [loggedin]);

  useEffect(async () => {
    if (mainState && mainState.length) {
      console.log("mainStata<><><><><><><><><><><><><><><><><><><>", mainState);
      let data = mainState?.filter((d) => d._id === match.params.id);

      setTokenData(data[0]);
      console.log("data[0]======-=-=-=-=>>>>>", data[0]);

      const gData = data[0].graphData;

      var finalData = gData?.map((data) => {
        return {
          x: new Date(Number(data.timeStamp) * 1000)
            .toString()
            .substring(4, 10),
          y: data.assetPriceUSD,
        };
      });

      console.log("=-=-=FINAL-=-=-=>", finalData);
      // setGraphData([
      //   {
      //     id: data[0].asset,
      //     color: "hsl(344, 70%, 50%)",
      //     data: finalData,
      //   },
      // ]);

      // console.log("ID====>>", decryptedObject);
    } else {
      history.push("/");
    }
  }, []);

  useEffect(() => {
    if (graphData1D) {
      setGraphData(graphData1D);
    }
  }, [graphData1D]);

  useEffect(() => {
    if (keyStore) {
      keyStore?.slice(0, 1)?.map((t) => {
        if (t?.asset) {
          setSelectedCurr(t);
        }
      });
    }
  }, [keyStore]);

  const handleCloseYay = () => setYayModal(false);

  const handleCloseConfirm = () => {
    setConfirmModal(false);
  };
  const handleShowConfirm = async () => {
    //check loggedin state
    let res;
    let inbound;
    let outboundTransactionFee;
    if (slipValue > slippagePercent) {
      setSlipError(true);
    } else {
      if (parseFloat(fromAmount) > 0) {
        // setConfirmModal(true);
        // console.log("----VAL===== ", parseFloat(fromAmount));
        inbound = await axios.get(INBOUND_ADDRESSES);
        outboundTransactionFee = await getOutboundTxFee();

        let rawData = assetFromString(selectedCurrTo?.rawData);
        let response = await calculateNetworkFee(
          rawData,
          inbound?.data,
          "OUTBOUND",
          selectedCurrTo
        );
        console.log("INBOUND FEE=========", outboundTransactionFee);
        console.log("responseCheck==========", response);
        setNetworkFee(response);
        submitSwap();
      } else {
        console.log("----VAL===== ", parseFloat(fromAmount));
        setEmptyError(true);
      }
    }
  };

  //Submit Swap
  const submitSwap = () => {
    setSlipError(false);
    if (loggedin) {
      // console.log("fromData=====>>", fromDataMain);
      let fromData;
      if (selectedCurr?.asset?.ticker === "RUNE") {
        fromData = RUNE;
      } else {
        fromData = midgardPool.find(
          (data) =>
            data.blockchain === selectedCurr.asset.chain &&
            data.asset === selectedCurr.asset.ticker
        );
      }
      const decimal = selectedCurr.amount.decimal;
      if (fromData) {
        dispatch(
          nativeSwapping(
            fromData,
            selectedCurrTo,
            fromAmount,
            toAmount,
            decimal,
            midgardPool,
            setYayModal,
            setConfirmModal,
            setTransactionHash,
            setStatusLink,
            setLoading,
            walletType,
            selectedCurr,
            memoSlip
          )
        );
      }
    } else {
      // console.log("loggedOUT");
      dispatch(handleMainModal(true));
    }
  };

  function financial(x) {
    return Number.parseFloat(x).toFixed(2);
  }
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const fromAmountHandler = (e) => {
    if (e.target.value === "") {
      setFromAmount("");
      setToAmount("");
    } else if (e.target.value >= 0) {
      setFromAmount(e.target.value);

      // setToAmount(Number(e.target.value) / Number(TokenPriceUSD));
    }
  };
  // const toAmountHandler = (e) => {
  //   if (e.target.value === "") {
  //     setFromAmount("");
  //     setToAmount("");
  //   } else if (e.target.value >= 0) {
  //     setToAmount(e.target.value);
  //     setFromAmount(Number(e.target.value) * Number(TokenPriceUSD));
  //   }
  // };
  const gettingLogos = (t) => {
    let midgardPool = mainState;

    let ticker = t?.asset?.ticker;
    if (t.asset.ticker.toLowerCase() === "rune") {
      return (
        <img
          src={Images.runeImg}
          width="24px"
          height="24px"
          style={{ marginRight: "6px" }}
        />
      );
    } else {
      let res = midgardPool?.find(
        (d) => d?.asset.toLowerCase() === ticker.toLowerCase()
      );
      return (
        <img
          src={res?.logo}
          width="24px"
          height="24px"
          style={{ marginRight: "6px" }}
        />
      );
    }
  };

  const gettingLogos2 = (t) => {
    if (t) {
      let midgardPool = mainState;

      let ticker = t?.asset?.ticker;
      if (t?.asset?.ticker?.toLowerCase() === "rune") {
        return (
          <img class="pt-1" style={{ height: "45px" }} src={Images.runeImg} />
        );
      } else {
        let res = midgardPool?.find(
          (d) => d?.asset?.toLowerCase() === ticker?.toLowerCase()
        );
        return <img class="pt-1" style={{ height: "45px" }} src={res?.logo} />;
      }
    }
  };

  function financial(x) {
    return Number.parseFloat(x).toFixed(2);
  }
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const statusRouting = () => {
    // history.push(statusLink);
    console.log("statusLink=====", statusLink);
  };

  const filterAllType = (e) => {
    e.preventDefault();
    setFilterType(Enum.allType);

    setKeyStore(assetBalance);
  };
  const filterNative = (e) => {
    e.preventDefault();
    setFilterType(Enum.native);

    let res = assetBalance.filter(
      (data) => data?.asset?.chain === data?.asset?.ticker
    );
    setKeyStore(res);
  };

  const filterERC20 = (e) => {
    e.preventDefault();
    setFilterType(Enum.erc20);

    let res = assetBalance.filter(
      (data) => data?.asset?.chain === "ETH" && data?.asset?.ticker !== "ETH"
    );
    setKeyStore(res);
  };

  const filterBEP2 = (e) => {
    e.preventDefault();
    setFilterType(Enum.bep2);

    let res = assetBalance.filter(
      (data) => data?.asset?.chain === "BNB" && data?.asset?.ticker !== "BNB"
    );
    setKeyStore(res);
  };

  /*TO */

  const filterAllTypeTo = (e) => {
    e.preventDefault();
    setFilterType2(Enum.allType);
    setMidgardData(mainState);
  };
  const filterNativeTo = (e) => {
    e.preventDefault();
    setFilterType2(Enum.native);
    let res = mainState.filter((data) => data?.blockchain === data?.asset);
    setMidgardData(res);
  };

  const filterERC20To = (e) => {
    e.preventDefault();
    setFilterType2(Enum.erc20);
    let res = mainState.filter(
      (data) => data?.blockchain === "ETH" && data?.asset !== "ETH"
    );
    setMidgardData(res);
  };

  const filterBEP2To = (e) => {
    e.preventDefault();
    setFilterType2(Enum.bep2);
    let res = mainState.filter(
      (data) => data?.blockchain === "BNB" && data?.asset !== "BNB"
    );
    setMidgardData(res);
  };
  const implementSearch = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    getCoinDescription();
  }, [tokenData?.assetFullName]);

  const [description, setDescription] = useState(
    "The worlds first Cryptocurrency, Bitcoin is stored and exchange securely on the internet through a digital ledger known as a blochchain. Bitcoins are divisible into smaller units known as satoshis-each satoshi is worth 0.00000001 bitcoin."
  );

  const getCoinDescription = async () => {
    axios
      .get(`${NGROK}/get/currency/by/name/${tokenData?.asset}`)
      .then(
        (e) => setDescription(e?.data?.description)
        // console.log("RES Selected curr desc ---- ", e?.data?.description),
      )
      .catch((e) => console.log("Error fetching selected cur desc ----- ", e));
  };

  const arrtemp = [];
  let opp = 0.9;
  let offSet = 0;
  for (
    let i = 0;
    i < graphData?.[0]?.data?.length;
    i = i + 2, opp = opp - 0.1, offSet = offSet + 10
  ) {
    if (opp < 0 || opp >= 1) {
      arrtemp.push({
        offset: offSet,
        color: "inherit",
        opacity: 0,
      });
    } else {
      arrtemp.push({
        offset: offSet,
        color: "inherit",
        opacity: opp.toFixed(2),
      });
    }
  }

  for (let i = 0; i <= 10; i++) {
    if (arrtemp[i] == undefined) {
      arrtemp.push({
        offset: i * 10,
        color: "inherit",
        opacity: 0,
      });
    }
  }
  console.log({ arrtemp });

  return (
    <>
      {/*Yay Pop Up Modal*/}
      {/*Noman work here start*/}
      <Modal
        show={YayModal}
        onHide={handleCloseYay}
        // backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          {/* <!-- Modal --> */}

          <div
            // class="modal fade"
            id="successBuy"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div>
              <div>
                <div class="modal-body">
                  <div class="d-flex flex-row justify-content-end">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="n-modalCloseIcon"
                      onClick={handleCloseYay}
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.29287 3.29287C3.68338 2.90237 4.31657 2.90237 4.70707 3.29287L9.99997 8.58577L15.2929 3.29287C15.6834 2.90237 16.3166 2.90237 16.7071 3.29287C17.0976 3.68338 17.0976 4.31657 16.7071 4.70707L11.4142 9.99997L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L9.99997 11.4142L4.70707 16.7071C4.31657 17.0976 3.68338 17.0976 3.29287 16.7071C2.90237 16.3166 2.90237 15.6834 3.29287 15.2929L8.58577 9.99997L3.29287 4.70707C2.90237 4.31657 2.90237 3.68338 3.29287 3.29287Z"
                        fill="#23262F"
                      />
                    </svg>
                  </div>
                  <div class="d-flex justify-content-center  mb-3">
                    <h1
                      class="n-yayText"
                      style={{
                        fontWeight: "500",
                        fontFamily: "Poppins",
                        fontSize: "30px",
                        // paddingRight: "10px",
                      }}
                    >
                      Transaction Submitted
                    </h1>
                    {/* <img src={Images.Yay} /> */}
                  </div>
                  <div class="d-flex justify-content-center ">
                    <p class="n-yayText text-center">
                      Please allow a few minutes while the transaction is being
                      processed. Go to notifications to see the status.
                    </p>
                  </div>
                  {/* <div class=" ">
                    <a
                      href={statusLink}
                      class=""
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        fontSize: "14px",
                        width: "450px",
                        display: "block",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                      target="_blank"
                    >
                      {statusLink}
                    </a>
                  </div> */}
                  {/* <div class="transactionclasss">
                    <div class="d-flex justify-content-between">
                      <p
                        style={{
                          color: "#777E90",
                          fontSize: "14px",
                          fontFamily: "Poppins",
                          lineHeight: "24px",
                          marginBottom: "10px",
                        }}
                      >
                        Status
                      </p>
                      <p
                        style={{
                          color: "#777E90",
                          fontSize: "14px",
                          paddingRight: "48px",
                          fontFamily: "Poppins",
                          lineHeight: "24px",
                          marginBottom: "10px",
                        }}
                      >
                        Transaction ID
                      </p>
                    </div>
                    <div class="d-flex justify-content-between">
                      <p
                        style={{
                          color: "#58BD7D",
                          fontWeight: "500",
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          marginBottom: "10px",
                        }}
                      >
                        Initiated
                      </p>
                      <br />
                      <p
                        class="n-modalSubHeading"
                        s
                        style={{
                          marginLeft: "50px",
                          fontWeight: "500",
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          overflow: "hidden",
                          lineHeight: "24px",
                          marginBottom: "10px",
                        }}
                      >
                        {transactionHash ? <> {transactionHash}</> : null}
                      </p>
                    </div>
                     <hr class="solid" /> 
                    <div class="d-flex flex-row justify-content-between">
                      <p
                        style={{
                          color: "#777E90",
                          fontSize: "14px",
                          paddingRight: "48px",
                          fontFamily: "Poppins",
                          lineHeight: "24px",
                          marginBottom: "0",
                        }}
                      >
                        Address
                      </p>
                      <p
                        class="n-modalSubHeading"
                        style={{
                          fontWeight: "500",
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          marginBottom: "0",
                          color: "#23262F",
                        }}
                      >
                        0msx836930...87r398
                      </p>
                    </div>
                  </div> */}
                  {/* <div class="d-flex justify-content-between pt-5"> */}
                  {/* <p
                      style={{
                        fontWeight: "500",
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#353945",
                      }}
                      class="n-modalSubHeading"
                    >
                      {toAmount}
                    </p>
                    <p
                      style={{
                        fontWeight: "500",
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#353945",
                      }}
                      class="n-modalSubHeading"
                    > */}
                  {/* BTC */}
                  {/* {selectedCurrTo?.asset}
                    </p> */}
                  {/* </div> */}
                  {/* <hr class="solid" /> */}
                  {/* <div class="d-flex justify-content-between">
                    <p
                      class="servicefee"
                      style={{
                        fontWeight: "500",
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#777E91",
                      }}
                    >
                      Service fee
                    </p>
                    <p
                      style={{
                        fontWeight: "600",
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#353945",
                      }}
                      class="n-modalSubHeading"
                    >
                      0.0045 ETH
                    </p>
                  </div> */}
                  {/* <div class="d-flex justify-content-between ">
                    <p
                      class="servicefee"
                      style={{
                        fontWeight: "500",
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#777E91",
                      }}
                    >
                      You will get
                    </p>
                    <p
                      style={{
                        fontWeight: "600",
                        fontFamily: "Poppins",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#353945",
                      }}
                      class="n-modalSubHeading"
                    >
                      {toAmount} {selectedCurrTo?.asset}
                    </p>
                  </div> */}
                </div>
                {/* <div class="d-flex justify-content-center pb-3 pt-2 pl-3 pr-3">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg btnHoverWhite"
                  >
                    Wallet
                  </button>
                </div> */}
                {/* New Transcation Modal According to Design Start Here */}

                <div class="n-swapCurrencies">
                  <div class="n-currencyFrom">
                    <div class="n-currencyLogoFrom">
                      <img src={Images.btc} alt="Currency From" />
                    </div>
                    <p
                      style={{
                        fontFamily: "DM Sans",
                        fontSize: "20px",
                        marginBottom: "0",
                        marginLeft: "10px",
                      }}
                    >
                      0.000632
                    </p>
                  </div>
                  <svg
                    width="26"
                    height="21"
                    viewBox="0 0 26 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 9.5C0.447715 9.5 0 9.94772 0 10.5C0 11.0523 0.447715 11.5 1 11.5V9.5ZM25 10.5L25.7071 11.2071C26.0976 10.8166 26.0976 10.1834 25.7071 9.79289L25 10.5ZM16.2071 0.292893C15.8166 -0.0976311 15.1834 -0.0976311 14.7929 0.292893C14.4024 0.683418 14.4024 1.31658 14.7929 1.70711L16.2071 0.292893ZM14.7929 19.2929C14.4024 19.6834 14.4024 20.3166 14.7929 20.7071C15.1834 21.0976 15.8166 21.0976 16.2071 20.7071L14.7929 19.2929ZM1 11.5H25V9.5H1V11.5ZM25.7071 9.79289L16.2071 0.292893L14.7929 1.70711L24.2929 11.2071L25.7071 9.79289ZM24.2929 9.79289L14.7929 19.2929L16.2071 20.7071L25.7071 11.2071L24.2929 9.79289Z"
                      fill="black"
                    />
                  </svg>

                  <div class="n-currencyFrom">
                    <div class="n-currencyLogoFrom">
                      <img src={Images.btc} alt="Currency From" />
                    </div>
                    <p
                      style={{
                        fontFamily: "DM Sans",
                        fontSize: "20px",
                        marginBottom: "0",
                        marginLeft: "10px",
                      }}
                    >
                      0.000632
                    </p>
                  </div>
                </div>
                <div class="n-currencyButtons">
                  <button class="n-secondaryButton">
                    View in notifcations
                  </button>
                  <button class="n-primaryButton">Done</button>
                </div>

                {/* New Transcation Modal According to Design End Here */}
              </div>
            </div>
          </div>
          {/* <!-- modal end --> */}
        </Modal.Body>
      </Modal>
      {/*Noman work here END*/}
      {/*Confirm PopUp Modal */}

      <Modal
        show={confirmModal}
        onHide={handleCloseConfirm}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        {/* <Modal.Header
          closeButton
          style={{ borderBottom: "none" }}
        ></Modal.Header> */}
        <Modal.Body>
          {/* <!-- Modal --> */}
          <div
            id="exampleModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div role="document">
              <div>
                <div class="modal-body">
                  <div class="d-flex justify-content-between pt-2 pb-2">
                    <div class="d-flex">
                      {/* <img
                        class="pt-3 backArrow"
                        style={{ height: "25px", marginTop: "3px" }}
                        onClick={handleCloseConfirm}
                        src={Images.lefttwoline}
                      /> */}
                      <svg
                        className="backArrow mr-2"
                        width="32"
                        height="33"
                        viewBox="0 0 32 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={handleCloseConfirm}
                        style={{
                          marginTop: "3px",
                        }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.2108 10.1876C12.6697 9.68812 11.8261 9.72186 11.3267 10.2629L7.01897 14.9296C6.5475 15.4403 6.5475 16.2276 7.01896 16.7383L11.3267 21.405C11.8261 21.9461 12.6697 21.9799 13.2108 21.4804C13.7519 20.9809 13.7856 20.1374 13.2861 19.5963L11.044 17.1673L23.9987 17.1673C24.7351 17.1673 25.332 16.5703 25.332 15.8339C25.332 15.0976 24.7351 14.5006 23.9987 14.5006L11.044 14.5006L13.2861 12.0717C13.7856 11.5306 13.7519 10.6871 13.2108 10.1876Z"
                          fill="#777E91"
                        />
                      </svg>
                      <p class="yahparagraph">Confirm</p>
                    </div>
                    <div>
                      {/* <img
                        className="settingmodlicon4444"
                        style={{
                          height: "25px",
                          marginTop: "10px",
                          cursor: "pointer",
                        }}
                        src={Images.setting}
                      /> */}
                    </div>
                  </div>
                  <div class="d-flex flex-wrap justify-content-between mt-5 pl-2 pl-md-5 pr-2 pr-md-5 pt-3 pb-3 n-confirmSwapModal">
                    <div class="d-flex">
                      {/* <img
                        class="pt-1"
                        style={{ height: "45px" }}
                        src={Images.From}
                      /> */}
                      {gettingLogos2(selectedCurr)}
                      <div class="pl-2">
                        <p
                          class="tranparagraph"
                          style={{ margin: "0px", fontFamily: "DM Sans" }}
                        >
                          From
                        </p>
                        <p
                          class="n-confirmValues"
                          style={{
                            fontWeight: "bold",
                            fontFamily: "Poppins",
                            fontSize: "14px",
                          }}
                        >
                          {fromAmount} {selectedCurr?.asset?.ticker}
                        </p>
                      </div>
                    </div>
                    <div class="d-flex">
                      <img
                        class="pt-1"
                        style={{ height: "45px" }}
                        src={selectedCurrTo?.logo}
                      />
                      <div class="pl-2">
                        <p
                          class="tranparagraph"
                          style={{ margin: "0px", fontFamily: "DM Sans" }}
                        >
                          {" "}
                          To
                        </p>
                        <p
                          class="n-confirmValues"
                          style={{
                            fontWeight: "bold",
                            fontFamily: "Poppins",
                            fontSize: "14px",
                          }}
                        >
                          {toAmount} {selectedCurrTo?.asset}
                        </p>
                      </div>
                    </div>
                    <div class="d-flex">
                      <img
                        class="pt-1"
                        style={{ height: "45px" }}
                        src={Images.proto}
                      />
                      <div class="pl-2">
                        <p
                          class="tranparagraph"
                          style={{ margin: "0px", fontFamily: "DM Sans" }}
                        >
                          {" "}
                          Protocol
                        </p>
                        <p
                          class="n-confirmValues"
                          style={{
                            fontWeight: "bold",
                            fontFamily: "Poppins",
                            fontSize: "14px",
                          }}
                        >
                          THORChain
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between pt-5">
                    <p
                      class="n-modalSubHeading"
                      style={{ fontWeight: "600", fontFamily: "DM Sans" }}
                    >
                      {toAmount}
                    </p>
                    <p
                      class="n-modalSubHeading"
                      style={{ fontWeight: "600", fontFamily: "DM Sans" }}
                    >
                      {selectedCurrTo?.asset}
                    </p>
                  </div>
                  <hr class="solid" />
                  <div class="d-flex justify-content-between">
                    <p class="servicefee">Network fee</p>
                    <p
                      class="n-modalSubHeading"
                      style={{ fontWeight: "600", fontFamily: "DM Sans" }}
                    >
                      {networkFee} {selectedCurrTo?.asset}
                    </p>
                  </div>
                  <div class="d-flex justify-content-between ">
                    <p class="servicefee">You will get</p>
                    <p
                      class="n-modalSubHeading"
                      style={{ fontWeight: "600", fontFamily: "DM Sans" }}
                    >
                      {toAmount} {selectedCurrTo?.asset}
                    </p>
                  </div>
                </div>
                <div class="d-flex justify-content-between pb-3 pt-2 pl-3 pr-3">
                  <button
                    style={{
                      // paddingLeft: "30px",
                      // paddingRight: "30px",
                      border: "2px solid #E6E8EC",
                      fontFamily: "DM Sans",
                      borderRadius: "25px",
                      fontWeight: "600",
                      // paddingTop: "10px",
                      // paddingBottom: "10px",
                    }}
                    type="button"
                    // class="btn btnHoverBlue n-modalCancelButton"
                    class="n-secondaryButton n-secondaryDark"
                    onClick={handleCloseConfirm}
                  >
                    Cancel
                  </button>
                  {/* <button
                    disabled={loading}
                    type="button"
                    style={{ fontSize: "16px", fontFamily: "DM Sans" }}
                    class="btn btn-primary btn-lg btnHoverWhite"
                    onClick={submitSwap}
                  >
                    I understand, continue
                  </button> */}
                  <button
                    style={{
                      // paddingLeft: "30px",
                      // paddingRight: "30px",
                      fontFamily: "DM Sans",
                      borderRadius: "25px",
                      fontWeight: "500",
                      // paddingTop: "10px",
                      // paddingBottom: "10px",
                      letterSpacing: "0.5px",
                      border: "2px solid rgb(55, 114, 255)",
                    }}
                    disabled={loading}
                    type="button"
                    // class="btnHoverWhite btn btn-primary"
                    className={`btn ${
                      loading
                        ? "btn n-primaryButtonDisabled"
                        : "btn n-primaryButton"
                    } n-primaryDark`}
                    onClick={submitSwap}
                  >
                    I understand, continue
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- modal end --> */}
        </Modal.Body>
      </Modal>
      {/* Div Started */}
      <section style={{ backgroundColor: "#F4F5F6" }}>
        <div
          class="swap-container"
          style={{ paddingTop: "20px", paddingBottom: "20px" }}
        >
          <div className="row">
            <div
              className="col-sm-12"
              style={{ paddingLeft: "10px", paddingRight: "10px" }}
            >
              <div
                style={{
                  borderRadius: "15px",
                  padding: "15px 15px",
                }}
                class="n-buyMarketRow"
              >
                <div className="row">
                  <div className="col-lg-4">
                    <div
                      className="d-flex align-items-center"
                      style={{ height: "100%" }}
                    >
                      <div>
                        {/* {console.log("nmbr --- ", check)} */}
                        <img
                          style={{
                            width: "18px",
                            margin: "0 10px",
                            cursor: "pointer",
                          }}
                          src={Images.iconsLeftline}
                          onClick={() =>
                            window.history.go(
                              Number(match.params.check) == 1 ? -2 : -1
                            )
                          }
                        />

                        <img
                          style={{ width: "32px", margin: "0 10px" }}
                          // src={Images.btc}
                          src={tokenData?.logo}
                        />
                      </div>
                      <div>
                        <h4 className="w-headinfswaming09888">
                          {tokenData?.assetFullName}
                        </h4>
                        <h4 className="w-headinfswaming01">
                          {tokenData?.asset}
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="d-flex justify-content-between flex-wrap u-swappingdonemain3455">
                      <div className="w-swap-top-inner">
                        <p class="w-marketparatwow">
                          {" "}
                          {/* <img src={Images.clock} /> */}
                          <img src={Images.up} /> Change
                        </p>

                        {tokenData?.change_24h >= 0 ? (
                          <>
                            <h5
                              style={{
                                color: "#00C076",
                                fontFamily: "DM Sans",
                                fontWeight: "500",
                                fontSize: "13px",
                                lineHeight: "17px",
                                marginBottom: "0",
                              }}
                            >
                              {numberWithCommas(
                                financial(tokenData?.assetPriceUSD)
                              )}{" "}
                              +{financial(tokenData?.change_24h)}%
                            </h5>
                          </>
                        ) : (
                          <>
                            <>
                              <h5
                                style={{
                                  color: "#f04e4e",
                                  fontFamily: "DM Sans",
                                  fontWeight: "500",
                                  fontSize: "13px",
                                  lineHeight: "17px",
                                  marginBottom: "0",
                                }}
                              >
                                $
                                {numberWithCommas(
                                  financial(tokenData?.assetPriceUSD)
                                )}
                                {/* {" "} */}({financial(tokenData?.change_24h)}
                                %)
                              </h5>
                            </>
                          </>
                        )}
                      </div>
                      <div className="w-swap-top-inner">
                        <p class="w-marketparatwow">
                          {" "}
                          <img src={Images.up} /> High
                        </p>
                        <h5
                          style={{
                            fontFamily: "DM Sans",
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17px",
                            marginBottom: "0",
                          }}
                        >
                          {tokenData?.change_24h_Highest >= 0 ? (
                            <>
                              $
                              {numberWithCommas(
                                financial(tokenData?.biggestVal)
                              )}
                              {/* + */}
                              {/* {financial(tokenData?.change_24h_Highest)}% */}
                            </>
                          ) : (
                            <>
                              {numberWithCommas(
                                financial(tokenData?.biggestVal)
                              )}
                              {/* {" "} */}
                              {/* {financial(tokenData?.change_24h_Highest)}% */}
                            </>
                          )}
                        </h5>
                      </div>
                      <div className="w-swap-top-inner">
                        <p class="w-marketparatwow">
                          {" "}
                          <img src={Images.down} /> Low
                        </p>
                        <h5
                          style={{
                            fontFamily: "DM Sans",
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17px",
                            marginBottom: "0",
                          }}
                        >
                          {tokenData?.change_24h_Lowest >= 0 ? (
                            <>
                              $
                              {numberWithCommas(
                                financial(tokenData?.smallestVal)
                              )}
                              {/* + */}
                              {/* {financial(tokenData?.change_24h_Lowest)}% */}
                            </>
                          ) : (
                            <>
                              $
                              {numberWithCommas(
                                financial(tokenData?.smallestVal)
                              )}
                              {/* {" "} */}
                              {/* {financial(tokenData?.change_24h_Lowest)}% */}
                            </>
                          )}{" "}
                        </h5>
                      </div>

                      <div className="w-swap-top-inner">
                        <p class="w-marketparatwow">
                          {" "}
                          <img src={Images.down} /> Volume
                        </p>
                        <h5
                          style={{
                            fontFamily: "DM Sans",
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17px",
                            marginBottom: "0",
                          }}
                        >
                          {tokenData?.change_24h >= 0 ? (
                            <>
                              $
                              {numberWithCommas(
                                financial(tokenData?.volume24h)
                              )}
                              {/* + */}
                              {/* {financial(tokenData?.change_24h)}% */}
                            </>
                          ) : (
                            <>
                              $
                              {numberWithCommas(
                                financial(tokenData?.volume24h)
                              )}
                              {/* {" "} */}
                              {/* {financial(tokenData?.change_24h)}% */}
                            </>
                          )}{" "}
                        </h5>
                      </div>
                      <div className="w-swap-top-inner d-flex justify-content-center align-items-center w-swap-top-inner-bg">
                        <h5
                          style={{
                            fontFamily: "DM Sans",
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17px",
                            marginBottom: "0",
                          }}
                        >
                          {selectedFilter}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section style={{ backgroundColor: "#F4F5F6" }}>
        <div class="swap-container">
          <div class="row">
            <div
              class="col-lg-8 order-2 order-lg-1"
              style={{
                marginBottom: "65px",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              <div
                class="n-buyMarketGraphSection"
                style={{ borderRadius: "15px" }}
              >
                <div
                  // style={{ height: "60px" }}
                  class="d-flex flex-wrap justify-content-between align-items-center n-buyGraphHeader"
                >
                  <div className="d-flex align-items-center">
                    <p className="u-burmarketmainpparagrpahj00 d-flex align-items-center">
                      {numberWithCommas(financial(tokenData?.assetPriceUSD))}{" "}
                      USD{" "}
                      {tokenData?.change_24h >= 0 ? (
                        <>
                          <span
                            style={{
                              color: "#4FBF67",
                              fontSize: "12px",
                              fontFamily: "Poppins",
                              fontWeight: "500",
                              marginLeft: "10px",
                            }}
                          >
                            +{financial(tokenData?.change_24h)}%
                          </span>
                        </>
                      ) : (
                        <>
                          <>
                            <span
                              style={{
                                color: "#f04e4e",
                                fontFamily: "DM Sans",
                                fontWeight: "500",
                                fontSize: "13px",
                                lineHeight: "17px",
                                marginBottom: "0",
                                marginLeft: "10px",
                              }}
                            >
                              {/* {" "} */} {financial(tokenData?.change_24h)}%
                            </span>
                          </>
                        </>
                      )}
                    </p>
                    <div className="ml-4 d-flex">
                      <button
                        className={
                          displayLineGraph
                            ? "btn w-swap-chartButtonAC mx-1"
                            : "btn w-swap-chartButton mx-1"
                        }
                        onClick={() => setDisplayLineGraph(true)}
                      >
                        Graph
                      </button>
                      <button
                        className={
                          displayLineGraph
                            ? "btn w-swap-chartButton mx-1"
                            : "btn w-swap-chartButtonAC mx-1"
                        }
                        onClick={() => {
                          setDisplayLineGraph(false);
                          setSelectedFilter("1M");
                          setGraphData(graphData1M);
                        }}
                      >
                        Candles
                      </button>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-end"
                    style={{
                      // marginTop: "40px",
                      paddingRight: "30px",
                    }}
                  >
                    {displayLineGraph ? (
                      <>
                        <button
                          // class="graphbutton"
                          onClick={() => {
                            setSelectedFilter("1H");
                            setGraphData(graphData1H);
                          }}
                          // style={{
                          //   color: selectedFilter == "1H" ? "#353945" : "#808191",
                          // }}
                          class={
                            selectedFilter == "1H"
                              ? "n-selectedFilter graphbutton"
                              : "n-unselectedFilter graphbutton"
                          }
                        >
                          1H
                        </button>
                        {/* <button class="graphbutton pl-2">24H</button> */}
                        <button
                          // class="graphbutton pl-2"
                          onClick={() => {
                            setSelectedFilter("1D");
                            setGraphData(graphData1D);
                          }}
                          // style={{
                          //   color: selectedFilter == "1D" ? "black" : "#808191",
                          // }}
                          class={
                            selectedFilter == "1D"
                              ? "n-selectedFilter graphbutton pl-2"
                              : "n-unselectedFilter graphbutton pl-2"
                          }
                        >
                          1D
                        </button>
                        <button
                          // class="graphbutton pl-2"
                          onClick={() => {
                            setSelectedFilter("1M");
                            setGraphData(graphData1M);
                          }}
                          // style={{
                          //   color: selectedFilter == "1M" ? "black" : "#808191",
                          // }}
                          class={
                            selectedFilter == "1M"
                              ? "n-selectedFilter graphbutton pl-2"
                              : "n-unselectedFilter graphbutton pl-2"
                          }
                        >
                          1M
                        </button>
                        <button
                          // class="graphbutton pl-2"
                          onClick={() => {
                            setSelectedFilter("1Y");
                            setGraphData(graphData1Y);
                          }}
                          // style={{
                          //   color: selectedFilter == "1Y" ? "black" : "#808191",
                          // }}
                          class={
                            selectedFilter == "1Y"
                              ? "n-selectedFilter graphbutton pl-2"
                              : "n-unselectedFilter graphbutton pl-2"
                          }
                        >
                          1Y
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          class="n-selectedFilter graphbutton pl-2"
                          onClick={() => {
                            setSelectedFilter("1M");
                            setGraphData(graphData1M);
                          }}
                          style={{
                            color: selectedFilter == "1M" ? "black" : "#808191",
                          }}
                        >
                          1M
                        </button>
                      </>
                    )}
                  </div>
                </div>

                <div
                  class=""
                  style={{
                    width: "100%",
                    height: "400px",
                    marginBottom: "20px",
                  }}
                >
                  {/* {console.log(
                    "graphdata<><><><><><><<><><><><><<><>><><><<>",
                    graphData
                  )}
                  {console.log(
                    "graphdata1D<><><><><><><<><><><><><<><>><><><<>",
                    graphData1D
                  )}{" "}
                  {console.log(
                    "graphdata1M<><><><><><><<><><><><><<><>><><><<>",
                    graphData1M
                  )}{" "}
                  {console.log(
                    "graphdata1H<><><><><><><<><><><><><<><>><><><<>",
                    graphData1H
                  )}{" "}
                  {console.log(
                    "graphdata1Y<><><><><><><<><><><><><<><>><><><<>",
                    graphData1Y
                  )} */}
                  {displayLineGraph && graphData.length ? (
                    <ResponsiveLine
                      enableGridX={false}
                      enableGridY={false}
                      key={graphData[0]?.data?.x}
                      data={graphData}
                      margin={{ top: 20, right: 30, bottom: 10, left: 70 }}
                      xScale={{ type: "point" }}
                      yScale={{
                        type: "linear",
                        min: "auto",
                        max: "auto",
                        stacked: true,
                        reverse: false,
                      }}
                      // curve="monotoneY"
                      yFormat=" >-.2f"
                      axisBottom={null}
                      colors={["#0046ff"]}
                      lineWidth={2}
                      enableArea={true}
                      areaOpacity={0.3}
                      axisTop={null}
                      axisRight={null}
                      // axisLeft={null}
                      axisLeft={{
                        orient: "left",

                        tickSize: 5,

                        tickPadding: 5,

                        tickRotation: 0,

                        // legend: "count",

                        legendOffset: -40,

                        legendPosition: "middle",
                      }}
                      theme={{
                        axis: {
                          ticks: {
                            line: {
                              stroke: "#808191",
                            },

                            text: {
                              fill: "#808191",
                            },
                          },
                        },
                      }}
                      tooltip={({ point }) => {
                        return (
                          <div
                            style={{
                              padding: "15px",
                              backgroundColor: "#353945",
                              borderRadius: "10px",
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              fontWeight: "400",
                            }}
                          >
                            <div className="my-1">
                              <span style={{ color: "#fcfcfd" }}>Date:</span>
                              <span
                                style={{ color: "#fff", marginLeft: "15px" }}
                              >
                                {/* 18435434.3424 */}
                                {typeof point.data.xFormatted !== "undefined"
                                  ? point.data.xFormatted
                                  : ""}
                              </span>
                            </div>
                            <div className="my-1">
                              <span style={{ color: "#fcfcfd" }}>
                                {/* Sum BTC: */}
                                Price:
                              </span>
                              <span
                                style={{ color: "#0052FF", marginLeft: "15px" }}
                              >
                                {/* 18435434 */}
                                {typeof point.data.yFormatted !== "undefined"
                                  ? "$" +
                                    numberWithCommas(point.data.yFormatted)
                                  : ""}
                              </span>
                            </div>
                            {/* <div className="my-1">
                              <span style={{ color: "#777e90" }}>
                                Sum USDT:
                              </span>
                              <span
                                style={{ color: "#17a2b8", marginLeft: "15px" }}
                              >
                                18435.434
                              </span>
                            </div> */}
                          </div>
                        );
                      }}
                      pointSize={0}
                      pointColor={{ theme: "background" }}
                      pointBorderWidth={2}
                      pointBorderColor={{ from: "serieColor" }}
                      pointLabelYOffset={-12}
                      useMesh={true}
                      areaBaselineValue={false}
                      defs={[
                        linearGradientDef(
                          "gradientA",
                          [
                            {
                              offset: 0,
                              // color: "#0046ff",
                              opacity: 0,
                            },
                            {
                              offset: parseInt(
                                graphData[0]?.data[
                                  graphData[0]?.data.length - 2
                                ]?.y
                              ),
                              // color: "#0046ff",
                              opacity: 0,
                            },
                          ]
                          // arrtemp.length > 1
                          //   ? [arrtemp[0], arrtemp[arrtemp.length - 1]]
                          //   : [
                          //       {
                          //         offset: 10,
                          //         color: "inherit",
                          //         opacity: 0.1,
                          //       },
                          //       {
                          //         offset: 100,
                          //         color: "inherit",
                          //         opacity: 0,
                          //       },
                          //     ]
                        ),
                        linearGradientDef("gradientB", [
                          { offset: 0, color: "#000" },
                          // { offset: 100, color: "inherit" },
                        ]),
                        // using plain object
                        {
                          id: "gradientC",
                          type: "linearGradient",
                          colors: [
                            { offset: 0, color: "#faf047", opacity: 1 },
                            // { offset: 10000, color: "#e4b400", opacity: 0 },
                          ],
                        },
                      ]}
                      fill={[{ match: "*", id: "gradientA" }]}
                      legends={[]}
                    />
                  ) : candleGraph?.length > 0 ? (
                    <Chart
                      options={{
                        options: {
                          chart: {
                            id: "candlestick",
                          },
                          // xaxis: {
                          //   categories: [
                          //     1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998,
                          //     1999,
                          //   ],
                          // },
                        },
                        yaxis: {
                          show: false,
                        },
                        xaxis: {
                          labels: {
                            show: false,
                          },
                          axisBorder: {
                            show: false,
                          },
                          axisTicks: {
                            show: false,
                          },
                          tooltip: {
                            enabled: false,
                          },
                        },
                        chart: {
                          toolbar: {
                            tools: {
                              download: false,
                            },
                          },
                        },
                        grid: {
                          show: false,
                        },
                        tooltip: {
                          fillSeriesColor: true,
                          theme: "dark",
                        },
                      }}
                      series={candleGraph}
                      type="candlestick"
                      width="100%"
                      height="100%"
                    />
                  ) : (
                    <div> </div>
                  )}
                </div>
                {console.log(
                  "----<><> CANDLE DATA CHECK <><>----- ",
                  candleGraph
                )}

                <div
                  style={{
                    paddingLeft: "30px",
                    paddingRight: "30px",
                    overflowX: "auto",
                  }}
                  class="d-flex justify-content-around n-buyGraphHeader"
                >
                  {graphCroppedData1H && selectedFilter == "1H"
                    ? graphCroppedData1H?.map((d) => (
                        <p
                          style={{
                            fontWeight: "400",
                            fontSize: "13px",
                            color: "#808191",
                          }}
                        >
                          {/* Sept15 */}
                          {d.x}
                        </p>
                      ))
                    : null}
                  {graphCroppedData1D && selectedFilter == "1D"
                    ? graphCroppedData1D?.map((d) => (
                        <p
                          style={{
                            fontWeight: "400",
                            fontSize: "13px",
                            color: "#808191",
                          }}
                        >
                          {/* Sept15 */}
                          {d.x}
                        </p>
                      ))
                    : null}
                  {graphCroppedData1M && selectedFilter == "1M"
                    ? graphCroppedData1M?.map((d) => (
                        <p
                          style={{
                            fontWeight: "400",
                            fontSize: "13px",
                            color: "#808191",
                          }}
                        >
                          {/* Sept15 */}
                          {d.x}
                        </p>
                      ))
                    : null}

                  {graphCroppedData1Y &&
                    selectedFilter == "1Y" &&
                    graphCroppedData1Y?.map((d) => (
                      <p
                        style={{
                          fontWeight: "400",
                          fontSize: "13px",
                          color: "#808191",
                        }}
                      >
                        {/* Sept15 */}
                        {d?.x}
                      </p>
                    ))}
                </div>

                {/* <hr class="solid" style={{ margin: "0px" }} /> */}
                <div class="row n-buyGraphHeader" style={{ margin: "0px" }}>
                  <div
                    class="col-lg-6 n-buyCurrencyCols"
                    // style={{ borderRight: "1px solid #f2f2f2" }}
                  >
                    <div class="d-flex pl-5 py-4">
                      {/* <img style={{ height: "40px" }} src={Images.pt1} /> */}
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                          fill="white"
                        />
                        <path
                          d="M20 39.5C30.7696 39.5 39.5 30.7696 39.5 20C39.5 9.23045 30.7696 0.5 20 0.5C9.23045 0.5 0.5 9.23045 0.5 20C0.5 30.7696 9.23045 39.5 20 39.5Z"
                          stroke="#E4E4E4"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M12 20C12 18.4178 12.4692 16.871 13.3482 15.5554C14.2273 14.2398 15.4767 13.2145 16.9385 12.609C18.4003 12.0035 20.0089 11.845 21.5607 12.1537C23.1126 12.4624 24.538 13.2243 25.6569 14.3431C26.7757 15.462 27.5376 16.8874 27.8463 18.4393C28.155 19.9911 27.9965 21.5997 27.391 23.0615C26.7855 24.5233 25.7602 25.7727 24.4446 26.6518C23.129 27.5308 21.5823 28 20 28C17.8802 27.9937 15.8491 27.1488 14.3501 25.6499C12.8512 24.1509 12.0063 22.1198 12 20V20Z"
                          fill="#0052FF"
                        />
                        <path
                          d="M16 20C16 19.2089 16.2346 18.4355 16.6741 17.7777C17.1136 17.1199 17.7384 16.6072 18.4693 16.3045C19.2002 16.0017 20.0044 15.9225 20.7804 16.0769C21.5563 16.2312 22.269 16.6122 22.8284 17.1716C23.3878 17.731 23.7688 18.4437 23.9231 19.2196C24.0775 19.9956 23.9983 20.7998 23.6955 21.5307C23.3928 22.2616 22.8801 22.8864 22.2223 23.3259C21.5645 23.7654 20.7911 24 20 24C18.9401 23.9968 17.9245 23.5744 17.1751 22.8249C16.4256 22.0755 16.0032 21.0599 16 20V20Z"
                          fill="#0052FF"
                        />
                      </svg>
                      <div class="pl-2">
                        <p
                          style={{
                            margin: "0px",
                            color: "#808191",
                            fontFamily: "DM Sans",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                        >
                          Market cap
                          {/* <i class="pl-2 fa fa-exclamation-circle"></i> */}
                          {/* <img class="pl-1 pt-1" src={Images.exclamation} /> */}
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="ml-2"
                          >
                            <path
                              d="M2.11616 9.88384C1.08555 8.85323 0.50455 7.45674 0.5 5.99926C0.500147 4.91172 0.822707 3.84863 1.42692 2.94437C2.03126 2.0399 2.89025 1.33495 3.89524 0.918665C4.90023 0.502383 6.0061 0.393465 7.073 0.605684C8.13989 0.817902 9.1199 1.34173 9.88909 2.11092C10.6583 2.8801 11.1821 3.86011 11.3943 4.92701C11.6065 5.9939 11.4976 7.09977 11.0813 8.10476C10.6651 9.10976 9.96011 9.96874 9.05564 10.5731C8.1514 11.1773 7.08835 11.4998 6.00084 11.5C4.54333 11.4955 3.14679 10.9145 2.11616 9.88384Z"
                              stroke="#808191"
                            />
                            <path
                              d="M6.75 5.25H5.25V9H6.75V5.25Z"
                              fill="#808191"
                            />
                            <path
                              d="M6 4.5C6.41421 4.5 6.75 4.16421 6.75 3.75C6.75 3.33579 6.41421 3 6 3C5.58579 3 5.25 3.33579 5.25 3.75C5.25 4.16421 5.58579 4.5 6 4.5Z"
                              fill="#808191"
                            />
                          </svg>
                        </p>
                        <p class="font-weight-bold">
                          {numberWithCommas(financial(tokenData?.marketCap))}{" "}
                          USD
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="d-flex pl-5 py-4 n-graphSecondCol">
                      {/* <img style={{ height: "40px" }} src={Images.pt2} /> */}
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                          fill="white"
                        />
                        <path
                          d="M20 39.5C30.7696 39.5 39.5 30.7696 39.5 20C39.5 9.23045 30.7696 0.5 20 0.5C9.23045 0.5 0.5 9.23045 0.5 20C0.5 30.7696 9.23045 39.5 20 39.5Z"
                          stroke="#E4E4E4"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M15 14C15 13.4477 14.5523 13 14 13C13.4477 13 13 13.4477 13 14V25C13 25.5523 13.4477 26 14 26C14.5523 26 15 25.5523 15 25V14Z"
                          fill="#0052FF"
                        />
                        <path
                          d="M19 19C19 18.4477 18.5523 18 18 18C17.4477 18 17 18.4477 17 19V25C17 25.5523 17.4477 26 18 26C18.5523 26 19 25.5523 19 25V19Z"
                          fill="#0052FF"
                        />
                        <path
                          d="M23 17C23 16.4477 22.5523 16 22 16C21.4477 16 21 16.4477 21 17V25C21 25.5523 21.4477 26 22 26C22.5523 26 23 25.5523 23 25V17Z"
                          fill="#0052FF"
                        />
                        <path
                          d="M27 22C27 21.4477 26.5523 21 26 21C25.4477 21 25 21.4477 25 22V25C25 25.5523 25.4477 26 26 26C26.5523 26 27 25.5523 27 25V22Z"
                          fill="#0052FF"
                        />
                      </svg>
                      <div class="pl-2">
                        <p
                          style={{
                            margin: "0px",
                            color: "#808191",
                            fontFamily: "DM Sans",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                        >
                          Volume (24h)
                          {/* <img class="pl-1 pt-1" src={Images.exclamation} /> */}
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="ml-2"
                          >
                            <path
                              d="M2.11616 9.88384C1.08555 8.85323 0.50455 7.45674 0.5 5.99926C0.500147 4.91172 0.822707 3.84863 1.42692 2.94437C2.03126 2.0399 2.89025 1.33495 3.89524 0.918665C4.90023 0.502383 6.0061 0.393465 7.073 0.605684C8.13989 0.817902 9.1199 1.34173 9.88909 2.11092C10.6583 2.8801 11.1821 3.86011 11.3943 4.92701C11.6065 5.9939 11.4976 7.09977 11.0813 8.10476C10.6651 9.10976 9.96011 9.96874 9.05564 10.5731C8.1514 11.1773 7.08835 11.4998 6.00084 11.5C4.54333 11.4955 3.14679 10.9145 2.11616 9.88384Z"
                              stroke="#808191"
                            />
                            <path
                              d="M6.75 5.25H5.25V9H6.75V5.25Z"
                              fill="#808191"
                            />
                            <path
                              d="M6 4.5C6.41421 4.5 6.75 4.16421 6.75 3.75C6.75 3.33579 6.41421 3 6 3C5.58579 3 5.25 3.33579 5.25 3.75C5.25 4.16421 5.58579 4.5 6 4.5Z"
                              fill="#808191"
                            />
                          </svg>
                        </p>
                        <p class="font-weight-bold">
                          {numberWithCommas(financial(tokenData?.volume24h))}{" "}
                          {tokenData?.asset}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <hr class="solid" style={{ margin: "0px" }} /> */}
                <div class="row n-buyGraphHeader" style={{ margin: "0px" }}>
                  <div
                    class="col-lg-6 n-buyCurrencyCols"
                    // style={{ borderRight: "1px solid #f2f2f2" }}
                  >
                    <div class="d-flex pl-5 py-4">
                      {/* <img style={{ height: "40px" }} src={Images.pt3} /> */}
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                          fill="white"
                        />
                        <path
                          d="M20 39.5C30.7696 39.5 39.5 30.7696 39.5 20C39.5 9.23045 30.7696 0.5 20 0.5C9.23045 0.5 0.5 9.23045 0.5 20C0.5 30.7696 9.23045 39.5 20 39.5Z"
                          stroke="#E4E4E4"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M20 18C22.9 18 26 17.1 26 15C26 12.9 22.9 12 20 12C17.1 12 14 12.9 14 15C14 17.1 17.1 18 20 18Z"
                          fill="#0052FF"
                        />
                        <path
                          d="M14 18.5V20C14 22.1 17.1 23 20 23C22.9 23 26 22.1 26 20V18.5C24.1787 19.549 22.1007 20.0685 20 20C17.8993 20.0685 15.8213 19.549 14 18.5V18.5Z"
                          fill="#0052FF"
                        />
                        <path
                          d="M14 23.5V25C14 27.1 17.1 28 20 28C22.9 28 26 27.1 26 25V23.5C24.1974 24.5945 22.1056 25.1174 20 25C17.8993 25.0685 15.8213 24.549 14 23.5V23.5Z"
                          fill="#0052FF"
                        />
                      </svg>
                      <div class="pl-2">
                        <p
                          style={{
                            margin: "0px",
                            color: "#808191",
                            fontFamily: "Poppins",
                            fontFamily: "DM Sans",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                        >
                          Circulating Supply
                          {/* <img class="pl-1 pt-1" src={Images.exclamation} /> */}
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="ml-2"
                          >
                            <path
                              d="M2.11616 9.88384C1.08555 8.85323 0.50455 7.45674 0.5 5.99926C0.500147 4.91172 0.822707 3.84863 1.42692 2.94437C2.03126 2.0399 2.89025 1.33495 3.89524 0.918665C4.90023 0.502383 6.0061 0.393465 7.073 0.605684C8.13989 0.817902 9.1199 1.34173 9.88909 2.11092C10.6583 2.8801 11.1821 3.86011 11.3943 4.92701C11.6065 5.9939 11.4976 7.09977 11.0813 8.10476C10.6651 9.10976 9.96011 9.96874 9.05564 10.5731C8.1514 11.1773 7.08835 11.4998 6.00084 11.5C4.54333 11.4955 3.14679 10.9145 2.11616 9.88384Z"
                              stroke="#808191"
                            />
                            <path
                              d="M6.75 5.25H5.25V9H6.75V5.25Z"
                              fill="#808191"
                            />
                            <path
                              d="M6 4.5C6.41421 4.5 6.75 4.16421 6.75 3.75C6.75 3.33579 6.41421 3 6 3C5.58579 3 5.25 3.33579 5.25 3.75C5.25 4.16421 5.58579 4.5 6 4.5Z"
                              fill="#808191"
                            />
                          </svg>
                        </p>
                        <p class="font-weight-bold">
                          {numberWithCommas(
                            financial(tokenData?.circulating_supply)
                          )}{" "}
                          USD
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="d-flex pl-5 py-4 n-graphSecondCol">
                      {/* <img style={{ height: "40px" }} src={Images.pt4} /> */}
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                          fill="white"
                        />
                        <path
                          d="M20 39.5C30.7696 39.5 39.5 30.7696 39.5 20C39.5 9.23045 30.7696 0.5 20 0.5C9.23045 0.5 0.5 9.23045 0.5 20C0.5 30.7696 9.23045 39.5 20 39.5Z"
                          stroke="#E4E4E4"
                          stroke-miterlimit="10"
                        />
                        <path
                          d="M17.9997 28V26H16.9997V28H14.9997V26C14.8663 26.008 14.7327 25.9876 14.6078 25.9402C14.4828 25.8928 14.3693 25.8194 14.2748 25.7249C14.1803 25.6304 14.1069 25.5169 14.0595 25.392C14.0121 25.267 13.9917 25.1334 13.9997 25V15C13.9917 14.8666 14.0121 14.733 14.0595 14.608C14.1069 14.4831 14.1803 14.3696 14.2748 14.2751C14.3693 14.1806 14.4828 14.1072 14.6078 14.0598C14.7327 14.0124 14.8663 13.992 14.9997 14V12H16.9997V14H17.9997V12H19.9997V14C20.3957 13.9928 20.789 14.0655 21.1562 14.2137C21.5235 14.3619 21.8571 14.5827 22.1371 14.8627C22.4171 15.1427 22.6378 15.4763 22.786 15.8435C22.9342 16.2107 23.0069 16.6041 22.9997 17C22.9817 17.3739 22.9144 17.7437 22.7997 18.1C23.7694 18.2971 24.6312 18.8475 25.2179 19.6444C25.8045 20.4412 26.0742 21.4275 25.9745 22.412C25.8748 23.3964 25.4129 24.3087 24.6784 24.9718C23.9439 25.6348 22.9892 26.0012 21.9997 26H19.9997V28H17.9997Z"
                          fill="#0052FF"
                        />
                      </svg>

                      <div class="pl-2">
                        <p
                          style={{
                            margin: "0px",
                            color: "#808191",
                            fontFamily: "DM Sans",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                        >
                          Total Supply
                          {/* <img class="pl-1 pt-1" src={Images.exclamation} /> */}
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="ml-2"
                          >
                            <path
                              d="M2.11616 9.88384C1.08555 8.85323 0.50455 7.45674 0.5 5.99926C0.500147 4.91172 0.822707 3.84863 1.42692 2.94437C2.03126 2.0399 2.89025 1.33495 3.89524 0.918665C4.90023 0.502383 6.0061 0.393465 7.073 0.605684C8.13989 0.817902 9.1199 1.34173 9.88909 2.11092C10.6583 2.8801 11.1821 3.86011 11.3943 4.92701C11.6065 5.9939 11.4976 7.09977 11.0813 8.10476C10.6651 9.10976 9.96011 9.96874 9.05564 10.5731C8.1514 11.1773 7.08835 11.4998 6.00084 11.5C4.54333 11.4955 3.14679 10.9145 2.11616 9.88384Z"
                              stroke="#808191"
                            />
                            <path
                              d="M6.75 5.25H5.25V9H6.75V5.25Z"
                              fill="#808191"
                            />
                            <path
                              d="M6 4.5C6.41421 4.5 6.75 4.16421 6.75 3.75C6.75 3.33579 6.41421 3 6 3C5.58579 3 5.25 3.33579 5.25 3.75C5.25 4.16421 5.58579 4.5 6 4.5Z"
                              fill="#808191"
                            />
                          </svg>
                        </p>
                        <p class="font-weight-bold">
                          {numberWithCommas(financial(tokenData?.total_supply))}{" "}
                          {tokenData?.asset}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <hr class="solid" style={{ margin: "0px" }} /> */}
                <div class="row">
                  <div class="col-lg-12 px-5 pt-5 pb-4">
                    <h2 class="bitcoinheadeing">
                      About {tokenData?.assetFullName}
                    </h2>
                    <p
                      style={{
                        // color: "#5e5b5b",
                        fontFamily: "Poppins",
                        fontSize: "14px",
                      }}
                      class="n-currencyDetailsParagraph"
                    >
                      {/* The worlds first Cryptocurrency, Bitcoin is stored and
                      exchange securely on the internet through a digital ledger
                      known as a blochchain. Bitcoins are divisible into smaller
                      units known as satoshis-each satoshi is worth 0.00000001
                      bitcoin. */}
                      {description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-lg-4 order-1 order-lg-2"
              style={{
                marginBottom: "20px",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              <div
                style={{
                  backgroundColor: "#FCFCFD",
                  height: "350px",
                  borderRadius: "15px",
                }}
                class="n-swapScreen"
                // className="pt-4 pb-4"
              >
                {/* <button
                class="mt-2"
                style={{
                  padding: "5px 15px 5px 15px",
                  border: "none",
                  borderRadius: "15px",
                  fontWeight: "bold",
                }}
              >
                <Link
                  to={browserRoute.MARKET}
                  style={{
                    textDecoration: "none",
                    color: "black",
                    fontFamily: "DM Sans",
                  }}
                >
                  Market
                </Link>
              </button> */}
                <div
                  style={{
                    padding: "15px",
                    height: "60px",
                  }}
                  class="d-flex justify-content-between n-swapHeader"
                >
                  <h2
                    style={{
                      color: "#23262F",
                      fontWeight: "600",
                      fontFamily: "DM Sans",
                      fontSize: "18px",
                      marginBottom: "0px",
                      width: "100%",
                    }}
                    class="d-flex justify-content-between"
                  >
                    <span class="n-swapBoxText">Swap</span>
                    <Setting_Modal setSlippagePercent={setSlippagePercent} />
                    {/* {tokenData?.asset} */}
                  </h2>
                </div>
                {/*Slippage*/}
                {/* <h6>Slippage: {slippagePercent}%</h6> */}
                <div style={{ padding: "20px 15px" }}>
                  <form class="w-currencyform">
                    <div class="input-group position-relative">
                      <div class="n-currencySelect" ref={myRefSwap}>
                        <div class="w-currency">
                          <div
                            class="d-flex flex-row align-items-center"
                            onClick={() => {
                              setOptionsDropdown(!optionsDropdown);
                            }}
                          >
                            {selectedCurr ? (
                              <> {gettingLogos(selectedCurr)}</>
                            ) : null}
                            {/* {selectedCurr?.asset?.ticker} */}
                            <img
                              style={{ width: "18px" }}
                              src={Images.iconarowdown}
                            />
                          </div>
                        </div>
                        {/* <ul className="n-currencyDropDown"> */}
                        <ul
                          class={
                            `n-currencyDropDown w-currency-height ` +
                            (optionsDropdown ? "d-block" : "d-none")
                          }
                        >
                          <ul className="w-pd-outer list-unstyled n-learnFilterLabels mb-2">
                            <li
                              className="d-flex flex-row justify-content-between align-items-center"
                              style={{ margin: "0 4px" }}
                            >
                              <button
                                className={
                                  filterType === Enum.allType
                                    ? "alltype alltypesDark"
                                    : "alltype-nonActive alltype-nonActiveDark"
                                }
                                style={{ color: "#fff", fontFamily: "DM Sans" }}
                                onClick={filterAllType}
                              >
                                All
                              </button>
                            </li>
                            <li
                              className="d-flex flex-row justify-content-center align-items-center"
                              style={{ margin: "0 4px" }}
                            >
                              <button
                                className={
                                  filterType === Enum.native
                                    ? "alltype alltypesDark"
                                    : "alltype-nonActive alltype-nonActiveDark"
                                }
                                style={{
                                  color: "#fff",
                                  fontFamily: "DM Sans",
                                  whiteSpace: "nowrap",
                                }}
                                onClick={filterNative}
                              >
                                Native
                              </button>
                            </li>
                            <li
                              className="d-flex flex-row justify-content-center align-items-center"
                              style={{ margin: "0 4px" }}
                            >
                              <button
                                className={
                                  filterType === Enum.erc20
                                    ? "alltype alltypesDark"
                                    : "alltype-nonActive alltype-nonActiveDark"
                                }
                                style={{ color: "#fff", fontFamily: "DM Sans" }}
                                onClick={filterERC20}
                              >
                                ERC20
                              </button>
                            </li>
                            <li
                              className="d-flex flex-row justify-content-center align-items-center"
                              style={{ margin: "0 4px" }}
                            >
                              <button
                                className={
                                  filterType === Enum.bep2
                                    ? "alltype alltypesDark"
                                    : "alltype-nonActive alltype-nonActiveDark"
                                }
                                style={{ color: "#fff", fontFamily: "DM Sans" }}
                                onClick={filterBEP2}
                              >
                                BEP2
                              </button>
                            </li>
                          </ul>
                          <div class="w-pd-outer d-flex form-group has-search mb-2 n-inputSearch w-100 ">
                            <input
                              type="text"
                              value={search}
                              class="form-control n-tableSearch n-tableSeachDark w-100"
                              placeholder="Search"
                              onChange={implementSearch}
                            />
                            <img
                              style={{
                                width: "20px",
                                height: "20px",
                                marginLeft: "-35px",
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                              src={Images.searchicon}
                            />
                          </div>

                          {keyStore
                            ?.filter((val) => {
                              return val?.asset?.ticker
                                ?.toLowerCase()
                                .includes(search?.toLowerCase());
                            })
                            .map((d, key) => {
                              return (
                                <>
                                  <li
                                    class="d-flex flex-row align-items-center w-hover-drop"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setSelectedCurr(d);
                                      setOptionsDropdown(false);
                                    }}
                                  >
                                    {gettingLogos(d)}
                                    {/* <img
                                src={Images.ltc}
                                // width="24px"
                                // height="24px"
                                style={{ marginRight: "6px" }}
                              /> */}
                                    <div class="d-flex flex-row align-items-center justify-content-between w-100 n-currencyDetails">
                                      <div class="n-currencyName d-flex flex-column justify-content-start">
                                        <p>{d?.asset?.ticker}</p>
                                        <span>Native</span>
                                      </div>
                                      <div
                                        class="n-currencyValue"
                                        // onClick={() => {
                                        //   setFromAmount(
                                        //     Number(d?.amount?.amount()?.c[0]) /
                                        //       Math.pow(10, d?.amount?.decimal)
                                        //   );
                                        // }}
                                      >
                                        {Number(d?.amount?.amount()?.c[0]) /
                                          Math.pow(10, d?.amount?.decimal)}{" "}
                                        {d?.asset?.ticker}
                                      </div>
                                    </div>
                                  </li>
                                  <hr className="m-0"></hr>
                                </>
                              );
                            })}
                        </ul>
                      </div>

                      {mainError ? (
                        <>
                          <input
                            disabled
                            style={{
                              borderRadius: "15px",
                              border: "2px solid #f6f6f6",
                              color: "#777E90",
                              fontSize: "14px",
                              backgroundColor: "#fcfcfd",
                              fontWeight: "600",
                              fontFamily: "DM Sans",
                              paddingLeft: "25%",
                              paddingRight: "18%",
                              textAlign: "right",
                              cursor: "not-allowed",
                            }}
                            type="text"
                            min={0}
                            class="form-control pt-4 pb-4"
                            aria-label="From"
                            aria-describedby="basic-addon2"
                          />
                        </>
                      ) : (
                        <input
                          style={{
                            borderRadius: "15px",
                            border: "2px solid #f6f6f6",
                            color: "#777E90",
                            fontSize: "14px",
                            backgroundColor: "#fcfcfd",
                            fontWeight: "600",
                            fontFamily: "DM Sans",
                            paddingLeft: "25%",
                            paddingRight: "18%",
                            textAlign: "right",
                          }}
                          onFocus={() => setEmptyError(false)}
                          type="text"
                          min={0}
                          value={fromAmount}
                          onChange={fromAmountHandler}
                          class="form-control pt-4 pb-4 n-btnWhite"
                          aria-label="From"
                          aria-describedby="basic-addon2"
                        />
                      )}
                      {/* <div class="input-group-append"> */}
                      <p
                        style={{
                          border: "none",
                          position: "absolute",
                          right: "4px",
                          top: "10px",
                          color: "#212529",
                          fontSize: "14px",
                          fontWeight: "600",
                          fontFamily: "DM Sans",
                          zIndex: "4",
                          boxShadow: "none",
                          cursor: "text",
                        }}
                        class="btn n-btnWhite"
                        type="button"
                      >
                        {selectedCurr?.asset?.ticker}
                        {/* USDT */}
                      </p>
                      {/* </div> */}
                    </div>
                  </form>
                  {/*end*/}
                  <div class="d-flex justify-content-between py-3 pr-2">
                    {slipError ? (
                      <>
                        <div
                          style={{
                            fontFamily: "DM Sans",
                            fontSize: "12px",
                            fontWeight: "600",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                            color: "red",
                          }}
                          class="pl-2 mb-0 n-swapAvailableBalance"
                        >
                          Slip: {slipValue} %
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          style={{
                            fontFamily: "DM Sans",
                            fontSize: "12px",
                            fontWeight: "600",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                          }}
                          class="pl-2 mb-0 n-swapAvailableBalance"
                        >
                          Slip: {slipValue} %
                        </div>
                      </>
                    )}

                    <div
                      style={{
                        fontSize: 10,
                        color: "red",
                        marginLeft: 16,
                        marginTop: -14,
                        // height: "5px",
                        // whiteSpace: "nowrap",
                      }}
                    >
                      {emptyError && <>* Swapping amount is required</>}
                      {slipError ? (
                        <>
                          * Your input value is exceeding from the slip amount.
                        </>
                      ) : null}
                    </div>
                    {/* <img
                    style={{
                      height: "15px",
                      width: "15px",
                      paddingTop: "2px",
                    }}
                    src={Images.bbbtc}
                  /> */}
                    <div class="d-flex">
                      <p
                        style={{
                          fontFamily: "DM Sans",
                          fontSize: "12px",
                          fontWeight: "400",
                          color: "#777e90",
                          whiteSpace: "nowrap",
                        }}
                        class="pl-2 mb-0"
                      >
                        Available Balance
                      </p>
                      <p
                        style={{
                          fontFamily: "DM Sans",
                          fontSize: "12px",
                          fontWeight: "600",
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                        }}
                        class="pl-2 mb-0 n-swapAvailableBalance"
                        onClick={() => {
                          setFromAmount(
                            financial(
                              Number(selectedCurr?.amount?.amount().c[0]) /
                                Math.pow(10, selectedCurr?.amount.decimal)
                            )
                          );
                          setToAmount(
                            Number(
                              financial(
                                Number(selectedCurr?.amount?.amount().c[0]) /
                                  Math.pow(10, selectedCurr?.amount.decimal)
                              )
                            ) / Number(TokenPriceUSD)
                          );
                        }}
                      >
                        {Number(selectedCurr?.amount?.amount().c[0]) /
                          Math.pow(10, selectedCurr?.amount.decimal)}{" "}
                        {selectedCurr?.asset?.ticker}
                      </p>
                    </div>
                  </div>

                  <form class="w-currencyform">
                    <div class="input-group mb-3">
                      <div class="n-currencySelect" ref={myRefSwap2}>
                        <div class="w-currency">
                          <div
                            class="d-flex flex-row align-items-center"
                            onClick={() => {
                              setToOptionDropDown(!toOptionDropDown);
                            }}
                          >
                            {selectedCurrTo ? (
                              <>
                                {" "}
                                <img
                                  src={selectedCurrTo.logo}
                                  width="24px"
                                  height="24px"
                                  style={{ marginRight: "6px" }}
                                />
                              </>
                            ) : null}
                            {/* {selectedCurrTo?.asset} */}
                            <img
                              style={{ width: "18px" }}
                              src={Images.iconarowdown}
                            />
                          </div>
                        </div>
                        {/* <ul className="n-currencyDropDown"> */}
                        <ul
                          class={
                            `n-currencyDropDown w-currency-height ` +
                            (toOptionDropDown ? "d-block" : "d-none")
                          }
                        >
                          <ul className="w-pd-outer list-unstyled n-learnFilterLabels mb-2">
                            <li
                              className="d-flex flex-row justify-content-between align-items-center"
                              style={{ margin: "0 4px" }}
                            >
                              <button
                                className={
                                  filterType2 === Enum.allType
                                    ? "alltype alltypesDark"
                                    : "alltype-nonActive alltype-nonActiveDark"
                                }
                                style={{ color: "#fff", fontFamily: "DM Sans" }}
                                onClick={filterAllTypeTo}
                              >
                                All
                              </button>
                            </li>
                            <li
                              className="d-flex flex-row justify-content-center align-items-center"
                              style={{ margin: "0 4px" }}
                            >
                              <button
                                className={
                                  filterType2 === Enum.native
                                    ? "alltype alltypesDark"
                                    : "alltype-nonActive alltype-nonActiveDark"
                                }
                                style={{
                                  color: "#fff",
                                  fontFamily: "DM Sans",
                                  whiteSpace: "nowrap",
                                }}
                                onClick={filterNativeTo}
                              >
                                Native
                              </button>
                            </li>
                            <li
                              className="d-flex flex-row justify-content-center align-items-center"
                              style={{ margin: "0 4px" }}
                            >
                              <button
                                className={
                                  filterType2 === Enum.erc20
                                    ? "alltype alltypesDark"
                                    : "alltype-nonActive alltype-nonActiveDark"
                                }
                                style={{ color: "#fff", fontFamily: "DM Sans" }}
                                onClick={filterERC20To}
                              >
                                ERC20
                              </button>
                            </li>
                            <li
                              className="d-flex flex-row justify-content-center align-items-center"
                              style={{ margin: "0 4px" }}
                            >
                              <button
                                className={
                                  filterType2 === Enum.bep2
                                    ? "alltype alltypesDark"
                                    : "alltype-nonActive alltype-nonActiveDark"
                                }
                                style={{ color: "#fff", fontFamily: "DM Sans" }}
                                onClick={filterBEP2To}
                              >
                                BEP2
                              </button>
                            </li>
                          </ul>
                          <div class="w-pd-outer d-flex form-group has-search mb-2 n-inputSearch w-100 ">
                            <input
                              type="text"
                              value={search}
                              class="form-control n-tableSearch n-tableSeachDark w-100"
                              placeholder="Search"
                              onChange={implementSearch}
                            />
                            <img
                              style={{
                                width: "20px",
                                height: "20px",
                                marginLeft: "-35px",
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                              src={Images.searchicon}
                            />
                          </div>

                          {midgardData
                            ?.filter((val) => {
                              return val?.asset
                                ?.toLowerCase()
                                .includes(search?.toLowerCase());
                            })
                            .map((d, key) => {
                              return (
                                <>
                                  <li
                                    class="d-flex flex-row align-items-center w-hover-drop"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setSelectedCurrTo(d);
                                      console.log(d);
                                      setToOptionDropDown(false);
                                    }}
                                  >
                                    <img
                                      src={d?.logo}
                                      width="24px"
                                      height="24px"
                                      style={{ marginRight: "6px" }}
                                    />
                                    {/* <img
                                src={Images.ltc}
                                // width="24px"
                                // height="24px"
                                style={{ marginRight: "6px" }}
                              /> */}
                                    <div class="d-flex flex-row align-items-center justify-content-between w-100 n-currencyDetails">
                                      <div class="n-currencyName d-flex flex-column justify-content-start">
                                        <p>{d?.asset}</p>
                                        <span>Native</span>
                                      </div>
                                      {/* <div class="n-currencyValue">0</div> */}
                                    </div>
                                  </li>
                                  <hr className="m-0"></hr>
                                </>
                              );
                            })}
                        </ul>
                      </div>
                      <input
                        style={{
                          borderRadius: "15px",
                          border: "2px solid #f6f6f6",
                          color: "#777E90",
                          fontSize: "14px",
                          backgroundColor: "#fcfcfd",
                          fontWeight: "600",
                          fontFamily: "DM Sans",
                          paddingLeft: "25%",
                          paddingRight: "18%",
                          textAlign: "right",
                        }}
                        type="text"
                        disabled
                        value={toAmount}
                        // onChange={toAmountHandler}
                        class="form-control pt-4 pb-4 n-btnWhite"
                        // placeholder="TO"
                        aria-label="From"
                        aria-describedby="basic-addon2"
                      />
                      {/* <div class="input-group-append"> */}
                      <p
                        style={{
                          border: "none",
                          position: "absolute",
                          right: "4px",
                          top: "10px",
                          fontSize: "14px",
                          color: "#212529",
                          fontWeight: "600",
                          fontFamily: "DM Sans",
                          zIndex: "4",
                          boxShadow: "none",
                          cursor: "text",
                        }}
                        class="btn n-btnWhite"
                        type="button"
                      >
                        {selectedCurrTo?.asset}
                      </p>
                      {/* </div> */}
                    </div>
                  </form>

                  {/* <div class="input-group mb-3 mt-3">
                <input
                  style={{ borderRight: "none" }}
                  type="text"
                  class="form-control"
                  placeholder="To"
                  aria-label="To"
                  aria-describedby="basic-addon2"
                />
                <div class="input-group-append">
                  <button
                    style={{ borderLeft: "none", borderColor: "#ced4da" }}
                    class="btn btn-outline-secondary"
                    type="button"
                  >
                    {tokenData?.asset}
                  </button>
                </div>
              </div> */}

                  {mainError ? (
                    <>
                      <button
                        disabled
                        style={{
                          fontSize: "16px",
                          fontFamily: "Dm Sans",
                          cursor: "not-allowed",
                        }}
                        type="button"
                        class="btn n-primaryButton n-primaryDark mt-3 w-100"
                        // onClick={handleShowConfirm}
                      >
                        Swap
                        {/* {tokenData?.asset} */}
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        disabled={loading}
                        style={{ fontSize: "16px", fontFamily: "Dm Sans" }}
                        type="button"
                        class="btn n-primaryButton n-primaryDark mt-3 w-100"
                        onClick={handleShowConfirm}
                      >
                        Swap
                        {/* {tokenData?.asset} */}
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default withMainLayout(BuyPlatform);
